import { BufferGeometry, Float32BufferAttribute } from 'three'
import { createNode } from './createNode'
import { courseModelOrigin, courseStationPose } from './courseLayout'

export function isCourseCollision(node) {
  for (let current = node; current; current = current.parent) {
    if (current.name === 'smily_collision' || current.name === 'chair_collision') return true
  }
  return false
}

// Bake full authoring hierarchy into model coordinates. PhysX colliders must
// be immediate children of the rigid body; no intermediate scaled groups.
export function courseCollisionGeometry(template) {
  template.updateMatrixWorld(true)
  const origin = courseModelOrigin(template)
  const geometry = []
  template.traverse(node => {
    if (!node.isMesh || !isCourseCollision(node)) return
    const source = node.geometry
    const position = source.getAttribute('position')
    if (!position || position.count < 3) throw new Error('course_collision_invalid')
    const baked = new BufferGeometry()
    const values = new Float32Array(position.count * 3)
    for (let i = 0; i < position.count; i++) {
      values[i * 3] = position.getX(i)
      values[i * 3 + 1] = position.getY(i)
      values[i * 3 + 2] = position.getZ(i)
    }
    baked.setAttribute('position', new Float32BufferAttribute(values, 3))
    if (source.index) baked.setIndex(source.index.clone())
    else baked.setIndex(Array.from({ length: position.count }, (_, index) => index))
    baked.applyMatrix4(node.matrixWorld)
    baked.translate(-origin[0], -origin[1], -origin[2])
    for (const value of baked.attributes.position.array) {
      if (!Number.isFinite(value)) { baked.dispose(); throw new Error('course_collision_invalid') }
    }
    geometry.push(baked)
  })
  return geometry
}
export function activateCourseCollisions(world, geometry, count, marker) {
  const bodies = []
  if (!geometry.length) return bodies
  try {
    for (let index = 0; index < count; index++) {
      const pose = courseStationPose(index, marker)
      const body = createNode('rigidbody', { type: 'static', position: pose.position, quaternion: pose.quaternion, tag: 'course-station' })
      bodies.push(body)
      for (const mesh of geometry) body.add(createNode('collider', { type: 'geometry', geometry: mesh, convex: false, trigger: false, layer: 'environment' }))
      body.activate({ world })
      if (!body.actor || body.children.some(node => !node.shape)) throw new Error('course_collision_activation_failed')
    }
    return bodies
  } catch (error) {
    for (const body of bodies) body.deactivate()
    throw error
  }
}
